import { render, staticRenderFns } from "./PdfReportEditor.vue?vue&type=template&id=39d37a86&scoped=true"
import script from "./PdfReportEditor.vue?vue&type=script&lang=js"
export * from "./PdfReportEditor.vue?vue&type=script&lang=js"
import style0 from "./PdfReportEditor.vue?vue&type=style&index=0&id=39d37a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d37a86",
  null
  
)

export default component.exports